/**
 * Rechtestand — eine kurze Kennung dessen, was ein Konto gerade darf.
 *
 * Jeder Dienst setzt sie in den Kopf `x-nadia-rechtestand` jeder beantworteten
 * Anfrage; jede Oberfläche vergleicht sie mit der, die sie kennt. Weichen sie
 * ab, hat jemand Rollen oder Stufe geändert, und die Oberfläche liest ihre
 * Sitzung sofort nach — ohne Neuladen und ohne auf den Takt zu warten. Eine
 * Änderung wirkt damit bei der nächsten Handlung, auf jeder Oberfläche gleich.
 *
 * Die Kennung ist **kein Geheimnis und keine Kryptografie**: Die Oberfläche
 * kennt ihre eigenen Rechte ohnehin. Gehasht wird nur, damit nicht die ganze
 * Liste in jedem Kopf mitfährt. FNV-1a, zweimal mit verschiedenem Startwert —
 * synchron, ohne Abhängigkeit, im Browser wie im Dienst dieselbe Rechnung.
 * Ein Zusammenstoß wäre kein Sicherheitsproblem: Dann bemerkt die Oberfläche
 * die Änderung erst im Takt, der Endpunkt setzt sie ohnehin sofort durch.
 */
export const RECHTESTAND_KOPF = 'x-nadia-rechtestand';
function fnv1a(text, start) {
    let h = start >>> 0;
    for (let i = 0; i < text.length; i += 1) {
        h ^= text.charCodeAt(i);
        h = Math.imul(h, 0x01000193) >>> 0;
    }
    return h.toString(16).padStart(8, '0');
}
/** Reihenfolge egal, Dubletten egal — nur die Menge zählt. */
export function rechtestand(rechte) {
    const liste = [...new Set(rechte)].sort().join('\n');
    return fnv1a(liste, 0x811c9dc5) + fnv1a(liste, 0x050c5d1f);
}
//# sourceMappingURL=rechtestand.js.map